// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CameraCameraComponent} from './CameraCamera.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCameraCamera = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CameraCameraComponent/>
  </Icon>
));
